import React from "react";
import { Popover } from "src/components/popover";
import LoginForm from "src/customer/login_form";
import SignUp from "src/customer/sign_up";

enum AccountFormType { "sign_in", "sign_up" }

const LinkAccountPopover = () => {
  const [accountForm, setAccountForm] = React.useState<AccountFormType>(AccountFormType.sign_in)

  const onLoginClick = (showPopover: () => void) => {
    setAccountForm(AccountFormType.sign_in);

    showPopover();
  }

  const onCreateAccountClick = (showPopover: () => void) => {
    setAccountForm(AccountFormType.sign_up);

    showPopover();
  }

  const unexpandedButton = (showPopover: () => void) => {
    return (
      <div className="field button-group">
        <a className="button" onClick={() => onLoginClick(showPopover)}>Log in</a>
        <a className="button" onClick={() => onCreateAccountClick(showPopover)}>Create account</a>
      </div>
    )
  }

  const expandedContent = (hidePopover: () => void) => {
    if (accountForm == AccountFormType.sign_in) {
      return (
        <LoginForm
          afterLoginCallback={() => { window.location.reload(); }}
          onRegisterSelect={() => { setAccountForm(AccountFormType.sign_up) }}
          onClose={hidePopover}
        />
      );
    } else {
      return (
        <SignUp
          afterSignUpCallback={() => { window.location.reload(); }}
          signInSelectCallback={() => { setAccountForm(AccountFormType.sign_in) }}
          onClose={hidePopover}
        />
      )
    }
  }

  return (
    <Popover
      unexpandedContent={unexpandedButton}
      expandedContent={expandedContent}
      options={{
        isFloatingOnDesktop: true,
        isModal: true,
      }}
    />
  );
}

export default LinkAccountPopover;
